import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantResidenceDurationPage = {
  alert: {
    error: 'coapplicant-residence-duration-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-residence-duration-page.footer.root',
  },
  form: {
    h1: 'coapplicant-residence-duration-page.form.h1',
    h2: 'coapplicant-residence-duration-page.form.h2',
    radioGroupRoot: 'coapplicant-residence-duration-page.form.radio-group-root',
    radioOption1: 'coapplicant-residence-duration-page.form.radio-option-1',
    radioOption2: 'coapplicant-residence-duration-page.form.radio-option-2',
    root: 'coapplicant-residence-duration-page.form.root',
    submitButton: 'coapplicant-residence-duration-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
